var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container accord24",
    staticStyle: {
      "width": "894px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("CERTIFICATE OF PROPERTY INSURANCE")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "piece"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.currentDate) + "\n        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "8px",
      "font-weight": "bold",
      "margin-top": "-10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5",
      "colspan": "6",
      "width": "50%"
    }
  }, [_vm._v("\n          PRODUCER\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.Producer),
      expression: "accord24.Producer"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text",
      "colspan": "6"
    },
    domProps: {
      "value": (_vm.accord24.Producer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "Producer", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.Producer))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n          CONTACT\n          "), _c('br'), _vm._v("NAME:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ContactName),
      expression: "accord24.ContactName"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ContactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ContactName", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ContactName) + " ")]) : _vm._e()])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            PHONE\n            "), _c('br'), _vm._v("(A/C,NO,Ext):\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.PhoneNumber),
      expression: "accord24.PhoneNumber"
    }],
    staticClass: "lg-60",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.PhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "PhoneNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.PhoneNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            FAX\n            "), _c('br'), _vm._v("(A/C,No):\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.FaxNumber),
      expression: "accord24.FaxNumber"
    }],
    staticClass: "lg-40",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.FaxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "FaxNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.FaxNumber) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n            E-MAIL\n            "), _c('br'), _vm._v("ADDRESS:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ContactEmailAddress),
      expression: "accord24.ContactEmailAddress"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ContactEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ContactEmailAddress", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ContactEmailAddress) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n            PRODUCER\n            "), _c('br'), _vm._v("CUSTOMER ID:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ProducerCustomerId),
      expression: "accord24.ProducerCustomerId"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ProducerCustomerId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ProducerCustomerId", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ProducerCustomerId) + " ")]) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6",
      "colspan": "6"
    }
  }, [_vm._v("\n            INSURED\n            "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.Insured),
      expression: "accord24.Insured"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.Insured)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "Insured", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.Insured))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER A:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerA_Name),
      expression: "accord24.InsurerA_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerA_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerA_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerA_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerA_NAIC),
      expression: "accord24.InsurerA_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerA_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerA_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.FaxNumber) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER B:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerB_Name),
      expression: "accord24.InsurerB_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerB_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerB_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerB_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerB_NAIC),
      expression: "accord24.InsurerB_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerB_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerB_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerB_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER C:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerC_Name),
      expression: "accord24.InsurerC_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerC_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerC_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerC_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerC_NAIC),
      expression: "accord24.InsurerC_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerC_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerC_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerC_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER D:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerD_Name),
      expression: "accord24.InsurerD_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerD_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerD_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerD_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerD_NAIC),
      expression: "accord24.InsurerD_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerD_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerD_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerD_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER E:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerE_Name),
      expression: "accord24.InsurerE_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerE_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerE_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerE_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerE_NAIC),
      expression: "accord24.InsurerE_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerE_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerE_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerE_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER F:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerF_Name),
      expression: "accord24.InsurerF_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerF_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerF_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerF_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerF_NAIC),
      expression: "accord24.InsurerF_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerF_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerF_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerF_NAIC) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "id": "middle_part"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": " 30%"
    }
  }, [_vm._v("\n          COVERAGES\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("\n          CERTIFICATE NUMBER:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.CertificateNumber),
      expression: "accord24.CertificateNumber"
    }],
    staticClass: "lg",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.CertificateNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "CertificateNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.CertificateNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("\n          REVISION NUMBER:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.RevisionNumber),
      expression: "accord24.RevisionNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.RevisionNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "RevisionNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.RevisionNumber) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticClass: "content3",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("\n          LOCATION OF PREMISES/DESCRIPTION OF PROPERTY (Use Additional Remarks, if more space is required)\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.PropertyDescription),
      expression: "accord24.PropertyDescription"
    }],
    staticClass: "lg md-textarea",
    attrs: {
      "data-limit-rows": "true",
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.PropertyDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "PropertyDescription", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.PropertyDescription))
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "11",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1),
      expression: "accord24.InsurerLetter1"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "17px"
    },
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsProperty),
      expression: "accord24.InsurerLetter1_IsProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsProperty)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("CAUSES OF LOSS")])]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "10",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_PolicyNumber),
      expression: "accord24.InsurerLetter1_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "10",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_EffectiveDate),
      expression: "accord24.InsurerLetter1_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "10",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ExpirationDate),
      expression: "accord24.InsurerLetter1_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBuilding),
      expression: "accord24.InsurerLetter1_IsBuilding"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBuilding) ? _vm._i(_vm.accord24.InsurerLetter1_IsBuilding, null) > -1 : (_vm.accord24.InsurerLetter1_IsBuilding)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBuilding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBuilding = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBuilding = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBuilding", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBuilding)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" BUILDING")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BuildingLimits),
      expression: "accord24.InsurerLetter1_BuildingLimits"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BuildingLimits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BuildingLimits", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BuildingLimits) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          DEDUCTIBLES\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsPersonalProperty),
      expression: "accord24.InsurerLetter1_IsPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" PERSONAL PROPERTY")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_PersonalPropertyLimit),
      expression: "accord24.InsurerLetter1_PersonalPropertyLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_PersonalPropertyLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_PersonalPropertyLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_PersonalPropertyLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBasic),
      expression: "accord24.InsurerLetter1_IsBasic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBasic) ? _vm._i(_vm.accord24.InsurerLetter1_IsBasic, null) > -1 : (_vm.accord24.InsurerLetter1_IsBasic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBasic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBasic = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBasic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBasic", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBasic)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BASIC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [_vm._v("\n          BUILDING\n          "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BuildingDeductible),
      expression: "accord24.InsurerLetter1_BuildingDeductible"
    }],
    staticStyle: {
      "height": "15px",
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BuildingDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BuildingDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BuildingDeductible) + " ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" CONTENTS\n          "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ContentsDeductible),
      expression: "accord24.InsurerLetter1_ContentsDeductible"
    }],
    staticStyle: {
      "height": "15px",
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ContentsDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ContentsDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ContentsDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBusinessIncome),
      expression: "accord24.InsurerLetter1_IsBusinessIncome"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBusinessIncome) ? _vm._i(_vm.accord24.InsurerLetter1_IsBusinessIncome, null) > -1 : (_vm.accord24.InsurerLetter1_IsBusinessIncome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBusinessIncome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBusinessIncome = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBusinessIncome = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBusinessIncome", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBusinessIncome)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BUSINESS INCOME")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BusinessIncomeLimit),
      expression: "accord24.InsurerLetter1_BusinessIncomeLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BusinessIncomeLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BusinessIncomeLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BusinessIncomeLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBroad),
      expression: "accord24.InsurerLetter1_IsBroad"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBroad) ? _vm._i(_vm.accord24.InsurerLetter1_IsBroad, null) > -1 : (_vm.accord24.InsurerLetter1_IsBroad)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBroad,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBroad = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBroad = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBroad", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBroad)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" BROAD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsExtraExpense),
      expression: "accord24.InsurerLetter1_IsExtraExpense"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsExtraExpense) ? _vm._i(_vm.accord24.InsurerLetter1_IsExtraExpense, null) > -1 : (_vm.accord24.InsurerLetter1_IsExtraExpense)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsExtraExpense,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsExtraExpense = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsExtraExpense = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsExtraExpense", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsExtraExpense)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("EXTRA EXPENSE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ExtraExpenseLimit),
      expression: "accord24.InsurerLetter1_ExtraExpenseLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ExtraExpenseLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ExtraExpenseLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ExtraExpenseLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsSpecial),
      expression: "accord24.InsurerLetter1_IsSpecial"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsSpecial) ? _vm._i(_vm.accord24.InsurerLetter1_IsSpecial, null) > -1 : (_vm.accord24.InsurerLetter1_IsSpecial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsSpecial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsSpecial = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsSpecial = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsSpecial", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsSpecial)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" SPECIAL")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsRentalValue),
      expression: "accord24.InsurerLetter1_IsRentalValue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsRentalValue) ? _vm._i(_vm.accord24.InsurerLetter1_IsRentalValue, null) > -1 : (_vm.accord24.InsurerLetter1_IsRentalValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsRentalValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsRentalValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsRentalValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsRentalValue", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsRentalValue)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("RENTAL VALUE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_RentalValueLimit),
      expression: "accord24.InsurerLetter1_RentalValueLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_RentalValueLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_RentalValueLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_RentalValueLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsEarthquake),
      expression: "accord24.InsurerLetter1_IsEarthquake"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsEarthquake) ? _vm._i(_vm.accord24.InsurerLetter1_IsEarthquake, null) > -1 : (_vm.accord24.InsurerLetter1_IsEarthquake)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsEarthquake,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsEarthquake = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsEarthquake = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsEarthquake", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsEarthquake)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" EARTHQUAKE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_EarthquakeDeductible),
      expression: "accord24.InsurerLetter1_EarthquakeDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_EarthquakeDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_EarthquakeDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_EarthquakeDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketBuilding),
      expression: "accord24.InsurerLetter1_IsBlanketBuilding"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketBuilding) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketBuilding, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketBuilding)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketBuilding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketBuilding = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketBuilding = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketBuilding", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketBuilding)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET BUILDING")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketBuildingLimit),
      expression: "accord24.InsurerLetter1_BlanketBuildingLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketBuildingLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketBuildingLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketBuildingLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsWind),
      expression: "accord24.InsurerLetter1_IsWind"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsWind) ? _vm._i(_vm.accord24.InsurerLetter1_IsWind, null) > -1 : (_vm.accord24.InsurerLetter1_IsWind)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsWind,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsWind = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsWind = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsWind", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsWind)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("WIND")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_WindDeductible),
      expression: "accord24.InsurerLetter1_WindDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_WindDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_WindDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_WindDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty),
      expression: "accord24.InsurerLetter1_IsBlanketPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET PERS PROP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits),
      expression: "accord24.InsurerLetter1_BlanketPersonalPropertyLimits"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketPersonalPropertyLimits", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsFlood),
      expression: "accord24.InsurerLetter1_IsFlood"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsFlood) ? _vm._i(_vm.accord24.InsurerLetter1_IsFlood, null) > -1 : (_vm.accord24.InsurerLetter1_IsFlood)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsFlood,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsFlood = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsFlood = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsFlood", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsFlood)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" FLOOD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_FloodDeductible),
      expression: "accord24.InsurerLetter1_FloodDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_FloodDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_FloodDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_FloodDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty),
      expression: "accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketBuildingAndPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET BLDG & PP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit),
      expression: "accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherInsurance1),
      expression: "accord24.InsurerLetter1_IsOtherInsurance1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherInsurance1) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherInsurance1, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherInsurance1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherInsurance1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherInsurance1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherInsurance1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherInsurance1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherInsurance1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherInsurance1),
      expression: "accord24.InsurerLetter1_OtherInsurance1"
    }],
    staticStyle: {
      "width": "60px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherInsurance1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherInsurance1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherInsurance1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherDeductible1),
      expression: "accord24.InsurerLetter1_OtherDeductible1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherDeductible1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherDeductible1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherDeductible1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherProperty1),
      expression: "accord24.InsurerLetter1_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherProperty1),
      expression: "accord24.InsurerLetter1_OtherProperty1"
    }],
    staticStyle: {
      "width": "100px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter1_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherInsurance2),
      expression: "accord24.InsurerLetter1_IsOtherInsurance2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherInsurance2) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherInsurance2, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherInsurance2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherInsurance2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherInsurance2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherInsurance2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherInsurance2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherInsurance2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherInsurance2),
      expression: "accord24.InsurerLetter1_OtherInsurance2"
    }],
    staticStyle: {
      "width": "60px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherInsurance2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherInsurance2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherInsurance2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherDeductible2),
      expression: "accord24.InsurerLetter1_OtherDeductible2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherDeductible2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherDeductible2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherDeductible2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherProperty2),
      expression: "accord24.InsurerLetter1_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherProperty2),
      expression: "accord24.InsurerLetter1_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherProperty2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter1_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "5",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2),
      expression: "accord24.InsurerLetter2"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsInlandMarine),
      expression: "accord24.InsurerLetter2_IsInlandMarine"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsInlandMarine) ? _vm._i(_vm.accord24.InsurerLetter2_IsInlandMarine, null) > -1 : (_vm.accord24.InsurerLetter2_IsInlandMarine)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsInlandMarine,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsInlandMarine = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsInlandMarine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsInlandMarine", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsInlandMarine)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("CAUSES OF LOSS")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          TYPE OF POLICY\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "4",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_EffectiveDate),
      expression: "accord24.InsurerLetter2_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "4",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_ExpirationDate),
      expression: "accord24.InsurerLetter2_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "rmbottom",
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty1),
      expression: "accord24.InsurerLetter2_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty1),
      expression: "accord24.InsurerLetter2_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_PolicyType),
      expression: "accord24.InsurerLetter2_PolicyType"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_PolicyType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_PolicyType", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_PolicyType) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty2),
      expression: "accord24.InsurerLetter2_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty2),
      expression: "accord24.InsurerLetter2_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("$\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsNamedPerils),
      expression: "accord24.InsurerLetter2_IsNamedPerils"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsNamedPerils) ? _vm._i(_vm.accord24.InsurerLetter2_IsNamedPerils, null) > -1 : (_vm.accord24.InsurerLetter2_IsNamedPerils)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsNamedPerils,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsNamedPerils = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsNamedPerils = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsNamedPerils", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsNamedPerils)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" NAMED PERILS")])]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          POLICY NUMBER\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty3),
      expression: "accord24.InsurerLetter2_IsOtherProperty3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty3) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty3, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty3", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_IsOtherProperty3) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty3),
      expression: "accord24.InsurerLetter2_OtherProperty3"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty3) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit3),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit3"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit3) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherInsurance4),
      expression: "accord24.InsurerLetter2_IsOtherInsurance4"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherInsurance4) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherInsurance4, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherInsurance4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherInsurance4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherInsurance4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherInsurance4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherInsurance4", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherInsurance4)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherInsurance4),
      expression: "accord24.InsurerLetter2_OtherInsurance4"
    }],
    staticStyle: {
      "width": "100px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherInsurance4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherInsurance4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherInsurance4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_PolicyNumber),
      expression: "accord24.InsurerLetter2_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty4),
      expression: "accord24.InsurerLetter2_IsOtherProperty4"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty4) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty4, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty4", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty4)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty4),
      expression: "accord24.InsurerLetter2_OtherProperty4"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit4),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit4"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit4) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3),
      expression: "accord24.InsurerLetter3"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsCrime),
      expression: "accord24.InsurerLetter3_IsCrime"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsCrime) ? _vm._i(_vm.accord24.InsurerLetter3_IsCrime, null) > -1 : (_vm.accord24.InsurerLetter3_IsCrime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsCrime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsCrime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsCrime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsCrime", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsCrime)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "spn"
  }, [_vm._v("TYPE OF POLICY")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_PolicyType),
      expression: "accord24.InsurerLetter3_PolicyType"
    }],
    staticStyle: {
      "width": "120px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_PolicyType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_PolicyType", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_PolicyType) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_PolicyNumber),
      expression: "accord24.InsurerLetter3_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_EffectiveDate),
      expression: "accord24.InsurerLetter3_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_ExpirationDate),
      expression: "accord24.InsurerLetter3_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty1),
      expression: "accord24.InsurerLetter3_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty1),
      expression: "accord24.InsurerLetter3_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty2),
      expression: "accord24.InsurerLetter3_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty2),
      expression: "accord24.InsurerLetter3_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty3),
      expression: "accord24.InsurerLetter3_IsOtherProperty3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty3) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty3, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty3", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty3)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty3),
      expression: "accord24.InsurerLetter3_OtherProperty3"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty3) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit3),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit3"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit3) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4),
      expression: "accord24.InsurerLetter4"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsBoiler),
      expression: "accord24.InsurerLetter4_IsBoiler"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsBoiler) ? _vm._i(_vm.accord24.InsurerLetter4_IsBoiler, null) > -1 : (_vm.accord24.InsurerLetter4_IsBoiler)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsBoiler,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsBoiler = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsBoiler = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsBoiler", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsBoiler)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_PolicyNumber),
      expression: "accord24.InsurerLetter4_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_EffectiveDate),
      expression: "accord24.InsurerLetter4_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_ExpirationDate),
      expression: "accord24.InsurerLetter4_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsOtherProperty1),
      expression: "accord24.InsurerLetter4_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter4_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter4_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherProperty1),
      expression: "accord24.InsurerLetter4_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter4_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsOtherProperty2),
      expression: "accord24.InsurerLetter4_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter4_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter4_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherProperty2),
      expression: "accord24.InsurerLetter4_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter4_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5),
      expression: "accord24.InsurerLetter5"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherInsurance1),
      expression: "accord24.InsurerLetter5_OtherInsurance1"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherInsurance1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherInsurance1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherInsurance1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_PolicyNumber),
      expression: "accord24.InsurerLetter5_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_EffectiveDate),
      expression: "accord24.InsurerLetter5_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_ExpirationDate),
      expression: "accord24.InsurerLetter5_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_IsOtherProperty1),
      expression: "accord24.InsurerLetter5_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter5_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter5_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter5_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter5_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter5_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter5_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter5_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter5_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherProperty),
      expression: "accord24.InsurerLetter5_OtherProperty"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherProperty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherProperty", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherProperty) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter5_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_IsOtherProperty2),
      expression: "accord24.InsurerLetter5_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter5_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter5_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter5_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter5_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter5_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter5_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter5_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter5_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherProperty2),
      expression: "accord24.InsurerLetter5_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter5_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "20"
    }
  }, [_vm._v("\n          SPECIAL CONDITIONS/OTER CVERAGES (Use Additional Remarks, if more space is required)\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.SpecialConditions),
      expression: "accord24.SpecialConditions"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.SpecialConditions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "SpecialConditions", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.SpecialConditions))
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "5",
      "colspan": "10"
    }
  }, [(!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.CertificateHolder),
      expression: "accord24.CertificateHolder"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "disabled": !_vm.readonly && !_vm.requestViewer,
      "placeholder": "Certificate Holder will be filled at time of request",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "CertificateHolder", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.CertificateHolder))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "content6",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "3",
      "colspan": "10"
    }
  }, [_vm._v("\n          SHOULD ANY OF THE ABOVE DESCRIBED POLICIES BE CANCELLED BEFORE\n          "), _c('BR'), _vm._v(" THE EXPIRATION DATE THEREOF, NOTICE WILL BE DELIVERED IN\n          "), _c('BR'), _vm._v(" ACCORDANCE WITH THE POLICY PROVISIONS.\n        ")], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "10"
    }
  }, [_vm._v("\n          AUTHORIZED REPRESENTATIVE\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.AuthorizedRepresentative),
      expression: "accord24.AuthorizedRepresentative"
    }],
    staticClass: "md-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.AuthorizedRepresentative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "AuthorizedRepresentative", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.AuthorizedRepresentative) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('h1', {
    staticClass: "title additional-remarks-header"
  }, [_vm._v("ADDITIONAL REMARKS")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "5",
      "colspan": "10"
    }
  }, [(!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.AdditionalRemarks),
      expression: "accord24.AdditionalRemarks"
    }],
    staticClass: "remarks-textarea",
    attrs: {
      "placeholder": "Use this section for additional remarks related to the policy and coverage",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.AdditionalRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "AdditionalRemarks", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "1225px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.AdditionalRemarks))
    }
  }) : _vm._e()])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n          DATE (MM/DD/YYYY)\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "content1",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n          THIS CERTIFICATE IS ISSUED AS A MATTER OF INFOMATION ONLY AND CONFERS NO RIGHTS UPON THE CERTIFICATE HOLDER. THIS CERTIFICATE\n          DOES NOT AFFIRMATIVELY OR NEGATIVELY AMEND, EXTEND OR ALTER THE COVERAGE AFFORDED BY THE POLICIES BELOW. THIS\n          CERTIFICATE OF INSURANCE DOES NOT CONSTITUTE A CONSTRACT VETWEEN THE ISSUING INSURER(S), AUTHORIZED REPRESENTATIVE\n          OR PRODUCER, AND THE CERTIFICATE HOLDER.\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER(S) AFFORDING COVERAGE\n          ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("\n            NAIC#\n          ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "content4",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("\n          THIS IS TO CERTFY THAT TIE POLICIES OF INSURANCE LISTED BELOW HAVE BEEN ISSUED TO THE INSURED NAMED ABOVE FOR THE POLICY\n          PERIOD INDICATED. NOTWITHSTANDING ANY REQUIREMENT, TERM OF CONDITION OF ANY CONTRACT OR OTHER DOCUMENT WITH RESPECT\n          TO WHICH THIS CERTIFICATE MAY BE ISSUSED OR MAY PERTAIN, THE INSURANCE AFFORDED BY THE POLICIES DESCRIBED HEREIN\n          IS SUBJECT TO ALL THE TERMS, EXCLUSIONS AND CONDITIONS OF SUCH POLICIES. LIMITS SHOWN MAY HAVE BEEN REDUCED BY\n          PAID CLAIMS.\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "content5"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          INSR\n          "), _c('br'), _vm._v("LTR\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          TYPE OF INSURANCE\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          POLICY NUMBER\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POLICY EFFECTIVE\n          "), _c('br'), _vm._v("DATE(MM/DD/YYYY)\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POLICYEXPIRATION\n          "), _c('br'), _vm._v("DATE(MM/DD/YYYY)\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          COVERED PROPERTY\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          LIMITS\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v("PROPERTY")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v(" INLAND MARINE")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v(" CRIME\n            ")]), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v(" BOILER & MACHINERY /\n              "), _c('br'), _vm._v(" EQUIPMENT BREAKDOWN\n            ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "id": "middle_part2"
    }
  }, [_c('tr', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("\n          CERTIFICATE HOLDER\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("\n          CANCELLATION\n        ")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0884f160","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/associations/Accord24.vue
// module id = +0L8
// module chunks = 1